import { DEFAULT_PRESETS_CHF } from '../constants/credits';

export type AmountProblem = 'invalid' | 'decimals' | 'minimum' | 'maximum';

/** Accepts 12.5 and 12,50, as someone typing German would. Returns null when it is not a number. */
export const parseAmount = (text: string): number | null => {
  const normalized = text.trim().replace(',', '.');
  return /^\d+(\.\d*)?$/.test(normalized) ? Number(normalized) : null;
};

export const amountProblem = (text: string, minChf: number, maxChf: number): AmountProblem | null => {
  const amount = parseAmount(text);
  if (amount === null) return 'invalid';
  if (/[.,]\d{3,}/.test(text)) return 'decimals';
  if (amount < minChf) return 'minimum';
  return amount > maxChf ? 'maximum' : null;
};

export const toMinor = (amountChf: number) => Math.round(amountChf * 100);

export const creditsFor = (amountChf: number, creditsPerChf: number) =>
  Math.round(amountChf * creditsPerChf);

/** Credits a coupon adds on top of what the amount buys; 0 for a coupon that only lowers the price. */
export const couponBonusCredits = (quoteCredits: number, amountChf: number, creditsPerChf: number) =>
  Math.max(0, quoteCredits - creditsFor(amountChf, creditsPerChf));

/** The first chip, CHF 10 on the standard list. */
export const defaultPreset = (presets: number[]): number | null => presets[0] ?? null;

export const presetsOrDefault = (presets?: number[]) =>
  presets?.length ? presets : DEFAULT_PRESETS_CHF;
